import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import HotSeries from './components/HotSeries';
import LatestUpdates from './components/LatestUpdates';
import StatsAbout from './components/StatsAbout';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/comics';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '073漫画网',
  url: 'http://aduvet.com/',
  description: siteInfo.description,
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://aduvet.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '073漫画网',
  url: 'http://aduvet.com/',
  description: siteInfo.description,
  contactPoint: {
    '@type': 'ContactPoint',
    email: siteInfo.contact.email,
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="韩国漫画无删减漫画下拉式-免费韩漫在线阅读"
        description="073漫画网推出无删减韩国漫画下拉式免费在线阅读，韩漫资源齐全，更新速度快，让您轻松探索韩漫世界的精彩。"
        keywords="韩国漫画,无删减漫画,下拉式韩漫,免费韩漫在线阅读,073漫画网"
        canonicalUrl="http://aduvet.com/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@graph': [homeJsonLd, orgJsonLd],
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedGrid />
        <HotSeries />
        <LatestUpdates />
        <StatsAbout />
        <Testimonials />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}